module.exports = function() {
  return new Worker(__webpack_public_path__ + "8ed79a2b82d631898d94.worker.js");
};